import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import DocumentVersionNote from '../../../interfaces/document-version-note';
import { BehaviorSubject } from 'rxjs';
import ID from '../../../types/id';
import {
  CREATE_NOTE,
  DELETE_NOTE,
  UPDATE_NOTE,
} from './graphql/document-notes';
import { isNode } from 'graphql/language/ast';
import { DefaultSnackBarService } from '../../../services/default-snack-bar.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentNotesService {
  constructor(
    public apollo: Apollo,
    private _snackBar: DefaultSnackBarService
  ) {}

  private _notes: DocumentVersionNote[] = [];
  private notes = new BehaviorSubject(this._notes);
  public notes$ = this.notes.asObservable();

  public setNotes(notes: DocumentVersionNote[]) {
    this._notes = notes;
    this.sortNotes();
  }
  private sortNotes() {
    this._notes = this._notes.sort((a, b) =>
      a.created > b.created ? -1 : b.created > a.created ? 1 : 0
    );
    this.notes.next(this._notes);
  }
  public createNote(
    document_version_id: ID,
    user_id: ID,
    note_text: string = ''
  ) {
    let sub = this.apollo
      .mutate({
        mutation: CREATE_NOTE,
        variables: {
          input: {
            document_version_id,
            user_id,
            note_text,
          },
        },
      })
      .subscribe(({ data, loading }) => {
        if (data?.createDocumentVersionNote) {
          this._notes.push(data.createDocumentVersionNote);
          this.sortNotes();
        }
        sub?.unsubscribe();
      });
  }
  public noteTextChange(note: DocumentVersionNote, note_text: string) {
    let noteIndex = this._notes.findIndex((iNote) => note.id === iNote.id);
    if (noteIndex > -1) {
      this._notes[noteIndex] = { ...this._notes[noteIndex], note_text };
      // this.notes.next(this._notes);
    }
  }
  public updateNote(id: ID, note_text: string) {
    let sub = this.apollo
      .mutate({
        mutation: UPDATE_NOTE,
        variables: { id, input: { note_text } },
      })
      .subscribe(({ data, loading }) => {
        if (data?.updateDocumentVersionNote) {
          let index = this._notes.findIndex(
            (note) => note.id === data.updateDocumentVersionNote.id
          );
          if (index > -1) {
            this._notes[index] = data.updateDocumentVersionNote;
            this.sortNotes();
          }
          this._snackBar.open('Successfully saved note');
        }
        sub?.unsubscribe();
      });
  }
  public deleteNote(id: ID) {
    let sub = this.apollo
      .mutate({ mutation: DELETE_NOTE, variables: { id } })
      .subscribe(({ data, loading }) => {
        if (data?.deleteDocumentVersionNote) {
          this._notes = this._notes.filter(
            (note) => note.id !== data.deleteDocumentVersionNote.id
          );
          this.notes.next(this._notes);
          this._snackBar.open('Successfully deleted note');
        }
        sub?.unsubscribe();
      });
  }
}
